// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__lk1Am","right":"styles_right__oqbn1"};